import { useSearchParams } from 'react-router-dom';

export function useIsReviewMode(): boolean {
    const [searchParams] = useSearchParams();
    return searchParams.has('review')
}
